import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-searchbox', // ✅ Cambié de 'app-search' a 'app-searchbox'
  standalone: true,
  imports: [CommonModule],
  templateUrl: './searchbox.component.html',
  styleUrl: './searchbox.component.scss',
})
export class SearchboxComponent implements OnInit {
  @Input() placeholder: string = 'Buscar...';
  @Output() searchChange = new EventEmitter<string>();

  private searchSubject = new Subject<string>();

  ngOnInit() {
  this.searchSubject.pipe(
    debounceTime(1000)
  ).subscribe(searchValue => {    
    this.searchChange.emit(searchValue);
  });
}

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }


  // Método para limpiar el input desde el componente padre
  clear() {
    const input = document.querySelector('input[type="text"]') as HTMLInputElement;
    if (input) {
      input.value = '';
      this.searchChange.emit('');
    }
  }
}